import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface FAQItem {
  question: string;
  answer: string;
  category: string;
}

const faqData: FAQItem[] = [
  // 게임 방법
  {
    category: '게임 방법',
    question: '말싸움은 어떤 게임인가요?',
    answer: '말싸움은 실시간 음성 토론 배틀 게임입니다. 다양한 주제에 대해 찬성/반대 진영으로 나뉘어 토론을 펼치고, 배심원들의 투표로 승패를 결정합니다. 텍스트가 아닌 음성으로 직접 토론하기 때문에 더 생생하고 역동적인 경험을 할 수 있습니다.',
  },
  {
    category: '게임 방법',
    question: '게임 진행 순서는 어떻게 되나요?',
    answer: '1) 주제와 입장(찬성/반대) 선택 → 2) 상대방과 자동 매칭 → 3) 입론(각 1분) → 4) 반론(각 1분) → 5) 최종 발언(각 30초) → 6) 배심원 투표 → 7) 결과 발표 순서로 진행됩니다. 각 단계마다 제한 시간이 있어 긴장감 있는 토론이 가능합니다.',
  },
  {
    category: '게임 방법',
    question: '배심원은 어떤 역할을 하나요?',
    answer: '배심원은 토론을 듣고 어느 쪽이 더 설득력 있는지 투표합니다. 토론자들의 논리, 근거, 표현력 등을 종합적으로 평가하여 투표하며, 더 많은 배심원 표를 받은 쪽이 승리합니다. 누구나 배심원으로 참여할 수 있습니다.',
  },
  {
    category: '게임 방법',
    question: '관전자로 참여할 수 있나요?',
    answer: '네, 토론에 직접 참여하지 않고 관전만 할 수도 있습니다. 관전자는 토론 내용을 듣고 이모지 반응을 남길 수 있습니다. 다음 게임에 참여하고 싶다면 대기열에 참가하면 됩니다.',
  },
  
  // 계정 & 프로필
  {
    category: '계정 & 프로필',
    question: '회원가입 없이 플레이할 수 있나요?',
    answer: '네, 게스트 모드로 바로 플레이할 수 있습니다. 단, 게스트 모드에서는 전적과 티어가 저장되지 않습니다. 지속적인 기록 관리와 랭킹 참여를 원하시면 회원가입을 권장합니다.',
  },
  {
    category: '계정 & 프로필',
    question: '티어 시스템은 어떻게 되나요?',
    answer: '브론즈 → 실버 → 골드 → 플래티넘 → 다이아몬드 순서로 올라갑니다. 각 티어는 5단계(V~I)로 나뉩니다. 승리하면 경험치를 얻고, 일정 경험치가 쌓이면 승급합니다. 패배 시에는 경험치가 소폭 감소합니다.',
  },
  {
    category: '계정 & 프로필',
    question: '프로필을 수정할 수 있나요?',
    answer: '네, 프로필 페이지에서 닉네임과 프로필 이미지를 변경할 수 있습니다. 닉네임은 다른 사용자와 중복될 수 없으며, 부적절한 닉네임은 제재 대상이 될 수 있습니다.',
  },
  
  // 기술 & 오류
  {
    category: '기술 & 오류',
    question: '마이크가 작동하지 않아요.',
    answer: '1) 브라우저에서 마이크 권한을 허용했는지 확인해주세요. 2) 다른 앱이 마이크를 사용 중인지 확인해주세요. 3) 브라우저를 새로고침하거나 재시작해보세요. 4) 크롬, 사파리, 엣지 등 최신 브라우저 사용을 권장합니다.',
  },
  {
    category: '기술 & 오류',
    question: '상대방 목소리가 안 들려요.',
    answer: '1) 기기의 볼륨이 켜져 있는지 확인해주세요. 2) 다른 탭의 미디어가 간섭하는지 확인해주세요. 3) 네트워크 연결 상태를 확인해주세요. 문제가 지속되면 게임을 나갔다가 다시 입장해보세요.',
  },
  {
    category: '기술 & 오류',
    question: '게임 중 연결이 끊겼어요.',
    answer: '네트워크 문제로 연결이 끊기면 자동으로 재연결을 시도합니다. 재연결에 실패하면 해당 게임은 무효 처리되며, 양측 모두 전적에 영향이 없습니다. 안정적인 Wi-Fi 또는 모바일 데이터 환경에서 플레이하시기 바랍니다.',
  },
  {
    category: '기술 & 오류',
    question: '어떤 브라우저를 사용해야 하나요?',
    answer: 'Chrome, Safari, Edge, Firefox 등 최신 버전의 브라우저를 권장합니다. 음성 통화 기능을 위해 WebRTC를 지원하는 브라우저가 필요합니다. Internet Explorer는 지원하지 않습니다.',
  },
  
  // 신고 & 제재
  {
    category: '신고 & 제재',
    question: '부적절한 사용자를 신고하려면?',
    answer: '게임 중 또는 결과 화면에서 신고 버튼을 눌러 신고할 수 있습니다. 욕설, 혐오 발언, 성희롱, 불법 행위 조장 등은 즉시 신고해주세요. 신고 내용은 운영팀에서 검토 후 조치합니다.',
  },
  {
    category: '신고 & 제재',
    question: '어떤 행위가 제재 대상인가요?',
    answer: '욕설 및 인신공격, 혐오 발언(인종, 성별, 종교 등), 성적 발언 및 성희롱, 불법 행위 조장, 의도적 게임 방해, 도배 및 광고 등이 제재 대상입니다. 자세한 내용은 커뮤니티 가이드라인을 참고해주세요.',
  },
  {
    category: '신고 & 제재',
    question: '제재를 받으면 어떻게 되나요?',
    answer: '위반 정도에 따라 경고, 일시 정지(1일~30일), 영구 정지 등의 조치가 이루어집니다. 제재에 이의가 있으면 문의하기를 통해 소명할 수 있습니다.',
  },
  
  // 기타
  {
    category: '기타',
    question: '토론 주제는 어떻게 선정되나요?',
    answer: '운영팀에서 시사, 사회, 문화, 일상 등 다양한 분야의 주제를 선정합니다. 누구나 찬성/반대 의견을 가질 수 있는 중립적인 주제를 선정하며, 정치적으로 편향되거나 불법적인 주제는 배제됩니다.',
  },
  {
    category: '기타',
    question: '새로운 기능을 제안하고 싶어요.',
    answer: '서비스 소개 페이지의 문의하기 폼을 통해 기능을 제안해주세요. 사용자 피드백은 서비스 개선에 큰 도움이 됩니다. 채택된 제안은 업데이트에 반영됩니다.',
  },
  {
    category: '기타',
    question: '광고는 왜 있나요?',
    answer: '말싸움은 무료 서비스로, 서버 운영 및 서비스 개선을 위해 광고 수익이 필요합니다. 광고는 게임 플레이에 최소한의 영향을 주도록 배치됩니다. 향후 프리미엄 구독을 통한 광고 제거 옵션도 고려 중입니다.',
  },
];

const categories = ['전체', ...Array.from(new Set(faqData.map((item) => item.category)))];

export default function FAQPage() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('전체');
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredFAQ = faqData.filter((item) => {
    const matchesCategory = selectedCategory === '전체' || item.category === selectedCategory;
    const matchesSearch =
      searchQuery === '' ||
      item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.answer.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <header className="border-b border-slate-700 py-4 px-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"
          >
            <span>←</span>
            <span>홈으로</span>
          </button>
          <h1 className="text-lg font-semibold">자주 묻는 질문</h1>
          <div className="w-20" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        {/* Title */}
        <div className="text-center mb-8">
          <div className="text-4xl mb-4">❓</div>
          <h2 className="text-2xl font-bold mb-2">자주 묻는 질문 (FAQ)</h2>
          <p className="text-slate-400">궁금한 점을 빠르게 찾아보세요</p>
        </div>

        {/* Search */}
        <div className="mb-6">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="질문 검색..."
            className="w-full px-4 py-3 bg-slate-800 rounded-lg border border-slate-700 focus:border-primary-500 focus:outline-none transition-colors"
          />
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-4 py-2 rounded-full text-sm transition-colors ${
                selectedCategory === category
                  ? 'bg-primary-600 text-white'
                  : 'bg-slate-800 text-slate-400 hover:text-white'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* FAQ List */}
        <div className="space-y-3">
          {filteredFAQ.length === 0 ? (
            <div className="text-center py-12 text-slate-400">
              <div className="text-4xl mb-4">🔍</div>
              <p>검색 결과가 없습니다.</p>
            </div>
          ) : (
            filteredFAQ.map((item, index) => (
              <div
                key={index}
                className="bg-slate-800/50 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
                  className="w-full px-6 py-4 flex items-start gap-4 text-left hover:bg-slate-800/80 transition-colors"
                >
                  <span className="text-primary-400 mt-0.5">Q</span>
                  <div className="flex-1">
                    <p className="font-medium">{item.question}</p>
                    <span className="text-xs text-slate-500">{item.category}</span>
                  </div>
                  <span
                    className={`text-slate-400 transition-transform ${
                      expandedIndex === index ? 'rotate-180' : ''
                    }`}
                  >
                    ▼
                  </span>
                </button>
                {expandedIndex === index && (
                  <div className="px-6 pb-4">
                    <div className="flex gap-4 pt-4 border-t border-slate-700">
                      <span className="text-green-400">A</span>
                      <p className="text-slate-300 leading-relaxed">{item.answer}</p>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 bg-slate-800/50 rounded-2xl p-6 text-center">
          <h3 className="font-semibold mb-2">원하는 답변을 찾지 못하셨나요?</h3>
          <p className="text-slate-400 text-sm mb-4">
            문의하기를 통해 직접 질문해주세요
          </p>
          <button
            onClick={() => navigate('/about')}
            className="btn-primary px-6 py-2 rounded-lg"
          >
            문의하기
          </button>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-700 py-8 px-4 mt-8">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400 mb-4">
            <button onClick={() => navigate('/')} className="hover:text-white transition-colors">
              홈
            </button>
            <button onClick={() => navigate('/about')} className="hover:text-white transition-colors">
              서비스 소개
            </button>
            <button onClick={() => navigate('/guidelines')} className="hover:text-white transition-colors">
              커뮤니티 가이드라인
            </button>
          </div>
          <p className="text-center text-slate-500 text-xs">
            © 2024 말싸움. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
